import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { getServiceFilterParams } from '@/pages/dashboard/utils/utils';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { getDefaultUtcDateValue } from '@/pages/dashboard/utils/dateUtils';

const NewUserChannleService = (props: any) => {
  const { children, api, byType, refreshKey = '', interval, metric, ...resetProps } = props || {};
  const contextObj = useContext(FilterContext);
  const { filterVal, filterLoading } = contextObj || {};
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);

  const data = useMemo(() => ({
    game_code: gameCode,
    by_type: byType ? byType : 'os',
    metric,
  }), [byType, gameCode, metric]);

  return (
    <Service
      api={api}
      data={data}
      refreshKey={refreshKey}
      interval={interval}
      dataKey={'data'}
      beforeRequest={(data) => {
        const { filterVal, game_code, by_type, metric } = data;
        const defaultTimeRange = getDefaultUtcDateValue(filterVal?.timeType, filterVal?.rangeTime);
        const filterParams = getServiceFilterParams(
          filterVal,
          defaultTimeRange,
        );
        const params = {
          game_code,
          by_type,
          metric,
          ...filterParams,
        };
        return params;
      }}
      trackData={['game_code', 'by_type', 'metric']}
      formatData={(data) => {
        // 数据格式转化
        const dates: string[] = [];
        const metrics: { name: string; values: string[]; }[] = [];
        const names: string[] = [];
        const total: string[] = [];
        data?.dwm_data_list?.forEach((item: any, index: number) => {
          dates.push(item.date_ymd);
          let itemTotal = 0;
          item?.list?.forEach((val: any, i: number) => {
            if (index === 0) {
              names.push(val.full_crz_name);
              metrics.push({
                name: val.full_crz_name,
                values: [val.value],
              });
            } else {
              metrics[i]?.values?.push(val.value);
            }
            itemTotal += Number(val.value);
          });
          total.push(String(itemTotal));
        });
        return {
          channels_of_new_user_total: dates.length,
          channels_of_new_user: {
            dates,
            metrics,
            names,
            total
          },
        };
      }}
    >
      {
        // 保证是jsx数组，而不是其他类型数组
        React.Children.map(children, (child: any) => React.cloneElement(child, {
          ...resetProps,
          filterVal,
          filterLoading,
        }))
      }
    </Service>
  );
};

export default NewUserChannleService;
